import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';


//
// PFA for store-external-challan-process


export const getStoreExternalWarehouseChallan = data => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store-external-warehouse/search-challan',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};




// Get Challan API :




// curl --location 'https://dhobicart.in/store/api/secure/v1/store-external-warehouse/search-challan' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6Ik9JVDM3NTcyIiwibG9nZ2VkSW5Vc2VyQnJhbmRJZCI6IjEiLCJzdWIiOiIxIiwiaWF0IjoxNzQzNjczMDc3LCJleHAiOjE3NDQyNzc4Nzd9.dpcmAIebyyVnQmWjnGIDZ7uBF0gicwQT4WXPBizjztAX0Zc8SxqP3NO0ofd2kx_rTsKcxtndgfx0eKoo3W5M1A' \
// --header 'Content-Type: application/json' \
// --header 'Cookie: JSESSIONID=53FE484F7C0EC52B3F42A3CCC0D485F2' \
// --data '{
//     "storeId" :1
// }'






export const addStoreExternalWarehouseChallan = (data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL + '/store/api/secure/v1/store-external-warehouse/challan',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};




// Add Challan API :


// curl --location 'https://dhobicart.in/store/api/secure/v1/store-external-warehouse/challan' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6Ik9JVDM3NTcyIiwibG9nZ2VkSW5Vc2VyQnJhbmRJZCI6IjEiLCJzdWIiOiIxIiwiaWF0IjoxNzQzNjczMDc3LCJleHAiOjE3NDQyNzc4Nzd9.dpcmAIebyyVnQmWjnGIDZ7uBF0gicwQT4WXPBizjztAX0Zc8SxqP3NO0ofd2kx_rTsKcxtndgfx0eKoo3W5M1A' \
// --header 'Content-Type: application/json' \
// --header 'Cookie: JSESSIONID=72347618CB7B828C5F26002C6CB4AC16' \
// --data '{
//     "createdDate" :"2025-04-08T12:25:26Z",
//     "challanTo" :"001",
//     "driverDetail" :"Sumit , 9718038845",
//     "vehicleDetail" :"up160101",
//     "otherInfo" :"abcd",
//     "challanNumber" :"123",
//     "storeId" :1


// }'


export const updateStoreExternalWarehouseChallan = (data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL + '/store/api/secure/v1/store-external-warehouse/challan',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


// Update Challan API :


// curl --location --request PUT 'https://dhobicart.in/store/api/secure/v1/store-external-warehouse/challan' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6Ik9JVDM3NTcyIiwibG9nZ2VkSW5Vc2VyQnJhbmRJZCI6IjEiLCJzdWIiOiIxIiwiaWF0IjoxNzQzNjczMDc3LCJleHAiOjE3NDQyNzc4Nzd9.dpcmAIebyyVnQmWjnGIDZ7uBF0gicwQT4WXPBizjztAX0Zc8SxqP3NO0ofd2kx_rTsKcxtndgfx0eKoo3W5M1A' \
// --header 'Content-Type: application/json' \
// --header 'Cookie: JSESSIONID=207D44BC2F52B1E91B6EC807A3F2D91C' \
// --data '{
//     "id":1,
//     "createdDate" :"2025-04-08T12:25:26Z",
//     "challanTo" :"001",
//     "driverDetail" :"Sumit , 9718038845",
//     "vehicleDetail" :"up160101",
//     "otherInfo" :"abcd",
//     "challanNumber" :"123",
//     "storeId" :1,
//     "status" : "create"


// }'


export const searchStoreExternalWarehouseChallan = data => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store-external-warehouse/search-challan',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


// curl --location 'https://dhobicart.in/store/api/secure/v1/store-external-warehouse/search-challan' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6Ik9JVDM3NTcyIiwibG9nZ2VkSW5Vc2VyQnJhbmRJZCI6IjEiLCJzdWIiOiIxIiwiaWF0IjoxNzQzNjczMDc3LCJleHAiOjE3NDQyNzc4Nzd9.dpcmAIebyyVnQmWjnGIDZ7uBF0gicwQT4WXPBizjztAX0Zc8SxqP3NO0ofd2kx_rTsKcxtndgfx0eKoo3W5M1A' \
// --header 'Content-Type: application/json' \
// --header 'Cookie: JSESSIONID=B348042DEE8A68CC39D5FC61571DDCA2' \
// --data '{
//     "storeId" :1,
//     "searchBy": "challanNumber",
//     "searchText":"ab",
//     "sortOrder" :"desc",
//     "sortBy" :"id",
//     "offset":0,
//     "limit" :5,
//     "startDate":"",
//     "endDate" :"",
//     "statusIn" : ["create", "sent"]
// }'






// Optional Params are


// {
//     "storeId" :1,
//     "searchByCanBe": "challanNumber"/"challanTo"/"driverDetail"/"vehicleDetail"/"otherInfo",
//     "searchText":"ab",
//     "sortOrder" :"desc",
//     "sortBy" :"id",
//     "offset":0,
//     "limit" :5,
//     "startDate":"",
//     "endDate" :"",
//     "statusIn" : ["create", "sent"]
// }


// Example :


// curl --location 'https://dhobicart.in/store/api/secure/v1/store-external-warehouse/search-challan' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6Ik9JVDM3NTcyIiwibG9nZ2VkSW5Vc2VyQnJhbmRJZCI6IjEiLCJzdWIiOiIxIiwiaWF0IjoxNzQzNjczMDc3LCJleHAiOjE3NDQyNzc4Nzd9.dpcmAIebyyVnQmWjnGIDZ7uBF0gicwQT4WXPBizjztAX0Zc8SxqP3NO0ofd2kx_rTsKcxtndgfx0eKoo3W5M1A' \
// --header 'Content-Type: application/json' \
// --header 'Cookie: JSESSIONID=B348042DEE8A68CC39D5FC61571DDCA2' \
// --data '{
//     "storeId" :1,
//     "searchBy": "challanNumber",
//     "searchText":"ab",
//     "sortOrder" :"desc",
//     "sortBy" :"id",
//     "offset":0,
//     "limit" :5,
//     "startDate":"",
//     "endDate" :"",
//     "statusIn" : ["create", "sent"]
// }'


export const addStoreExternalWarehouseChallanQrcode = (challanId,data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL + '/store/api/secure/v1/store-external-warehouse/challan/' + challanId + '/qrcode' ,
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


// Add QRCode in Challan API :


//  curl --location 'https://dhobicart.in/store/api/secure/v1/store-external-warehouse/challan/1/qrcode' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6Ik9JVDM3NTcyIiwibG9nZ2VkSW5Vc2VyQnJhbmRJZCI6IjEiLCJzdWIiOiIxIiwiaWF0IjoxNzQzNjczMDc3LCJleHAiOjE3NDQyNzc4Nzd9.dpcmAIebyyVnQmWjnGIDZ7uBF0gicwQT4WXPBizjztAX0Zc8SxqP3NO0ofd2kx_rTsKcxtndgfx0eKoo3W5M1A' \
// --header 'Content-Type: application/json' \
// --header 'Cookie: JSESSIONID=B67B845950D2740A30BEF413B6A77E02' \
// --data '{
//     "qrCodeIds" :[38816]
// }'




export const getStoreExternalWarehouseChallanQrcode = challanId => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store-external-warehouse/challan/' +
      challanId +
      '/qrcode',
    headers: getHeaders(),
  });
};




// Get Challan-QRCode API :




// curl --location 'https://dhobicart.in/store/api/secure/v1/store-external-warehouse/challan/1/qrcode' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6Ik9JVDM3NTcyIiwibG9nZ2VkSW5Vc2VyQnJhbmRJZCI6IjEiLCJzdWIiOiIxIiwiaWF0IjoxNzQzNjczMDc3LCJleHAiOjE3NDQyNzc4Nzd9.dpcmAIebyyVnQmWjnGIDZ7uBF0gicwQT4WXPBizjztAX0Zc8SxqP3NO0ofd2kx_rTsKcxtndgfx0eKoo3W5M1A' \
// --header 'Cookie: JSESSIONID=FCCD64FA16A6CB72F43592CE55AF2D80'




export const removeStoreExternalWarehouseChallanQrcode = ({challanId, data}) => {
  return axios({
    method: 'delete',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store-external-warehouse/challan/' +
      challanId +
      '/qrcode',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};




// Remove Challan-QRCode API :


// curl --location --request DELETE 'https://dhobicart.in/store/api/secure/v1/store-external-warehouse/challan/1/qrcode' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6Ik9JVDM3NTcyIiwibG9nZ2VkSW5Vc2VyQnJhbmRJZCI6IjEiLCJzdWIiOiIxIiwiaWF0IjoxNzQzNjczMDc3LCJleHAiOjE3NDQyNzc4Nzd9.dpcmAIebyyVnQmWjnGIDZ7uBF0gicwQT4WXPBizjztAX0Zc8SxqP3NO0ofd2kx_rTsKcxtndgfx0eKoo3W5M1A' \
// --header 'Content-Type: application/json' \
// --header 'Cookie: JSESSIONID=37EC875B7E1EE5D53268BCF9E8930084' \
// --data '{
//     "qrCodeIds" :[38816]
// }'


export const removeStoreExternalWarehouseChallanQrcodeById = (challanId,qrCodeId) => {
  return axios({
    method: 'delete',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store-external-warehouse/challan/' +
      challanId +
      '/qrcode/' + qrCodeId,    
    headers: getHeaders(),
  });
};




// Remove Challan-QRCode  API BY Id :


// curl --location --request DELETE 'https://dhobicart.in/store/api/secure/v1/store-external-warehouse/challan/1/qrcode/2' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6Ik9JVDM3NTcyIiwibG9nZ2VkSW5Vc2VyQnJhbmRJZCI6IjEiLCJzdWIiOiIxIiwiaWF0IjoxNzQzNjczMDc3LCJleHAiOjE3NDQyNzc4Nzd9.dpcmAIebyyVnQmWjnGIDZ7uBF0gicwQT4WXPBizjztAX0Zc8SxqP3NO0ofd2kx_rTsKcxtndgfx0eKoo3W5M1A' \
// --header 'Cookie: JSESSIONID=FD3F395A16426121979536AD5B19685E'




export const getStoreExternalWarehouseChallanQrcodePrintView = (challanId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store-external-warehouse/challan/' +
      challanId +
      '/qrcode-print-view',
    headers: getHeaders(),
   
  });
};


// Challan-QRCode Print-view API :




// curl --location 'https://dhobicart.in/store/api/secure/v1/store-external-warehouse/challan/1/qrcode-print-view' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6Ik9JVDM3NTcyIiwibG9nZ2VkSW5Vc2VyQnJhbmRJZCI6IjEiLCJzdWIiOiIxIiwiaWF0IjoxNzQzNjczMDc3LCJleHAiOjE3NDQyNzc4Nzd9.dpcmAIebyyVnQmWjnGIDZ7uBF0gicwQT4WXPBizjztAX0Zc8SxqP3NO0ofd2kx_rTsKcxtndgfx0eKoo3W5M1A' \
// --header 'Cookie: JSESSIONID=E36B4DCFF39B35E8624976233A086383'
